import { clsx } from 'clsx'
import { type FC } from 'react'

import { NfcLandingPageHeroBubble } from './NfcLandingPageHeroBubble'
import { NfcLandingPageHeroTitleOnlyText } from './NfcLandingPageHeroTitleOnlyText'

export const NfcLandingPageHeroTitleBanner: FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div
      className={clsx(
        'flex items-center gap-2 bg-light-brand-medium p-4 tablet:gap-4',
        className,
      )}
    >
      <NfcLandingPageHeroTitleOnlyText
        className="mt-px flex-1 text-start"
        shouldWrap={false}
      />
      <NfcLandingPageHeroBubble />
    </div>
  )
}
